import { SSEService } from '@/shared/services/sse';

export const SSECrmCheckedInChannel = SSEService.createEventChannel('crm.checked-in');
